var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('filter-popover',{attrs:{"value":_vm.value,"initial":_vm.initial,"fields":_vm.fields,"close-on-accept":false,"no-fields-description":_vm.labels.noFields,"deferable":""},on:{"change":_vm.change,"confirm":_vm.confirm}},[_c('template',{slot:"button"},[_c('is-button',{attrs:{"icon":"gear","dark":""}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }